export const EnvTypes = {
  DEV: 'dev',
  HML: 'hml',
  PRD: 'prod',
  TRN: 'trn',
};
